<aside class="sidebar">
  <!-- Brand -->
  <div class="sidebar__brand">
    <div class="sidebar__logo" aria-hidden="true">M</div>
    @if (!collapsed()) {
      <div class="sidebar__brand-text">
        <span class="sidebar__brand-name">MERCURE</span>
        <span class="sidebar__brand-sub">Collect AI</span>
      </div>
    }
    <button
      class="sidebar__collapse-btn"
      type="button"
      [attr.aria-label]="collapsed() ? 'Étendre le menu' : 'Réduire le menu'"
      [attr.aria-expanded]="!collapsed()"
      (click)="toggleCollapsed()">
      <mc-icon name="chevron-left" class="sidebar__collapse-icon" />
    </button>
  </div>

  <!-- Navigation: common section + role-contextual section, kept close together -->
  <nav class="sidebar__nav" aria-label="Navigation">
    <div class="sidebar__common-nav">
      <mc-side-nav-panel
        variant="dark"
        title="Principal"
        [collapsed]="collapsed()"
        [items]="commonMenu()" />
    </div>

    @if (contextualMenu().length > 0) {
      <div class="sidebar__ctx-nav">
        <mc-side-nav-panel
          variant="dark"
          [title]="sectionTitle()"
          [collapsed]="collapsed()"
          [items]="contextualMenu()" />
      </div>
    }
  </nav>

  <!-- Profile footer -->
  <div class="sidebar__footer">
    <button
      class="sidebar__profile"
      type="button"
      [attr.aria-label]="'Profil utilisateur — ' + user().name"
      [attr.title]="collapsed() ? user().name : null">
      <div class="sidebar__avatar" aria-hidden="true">{{ user().avatarInitials }}</div>
      @if (!collapsed()) {
        <div class="sidebar__profile-text">
          <span class="sidebar__agent-name">{{ user().name }}</span>
          <span class="sidebar__role-sub">{{ roleLabel() }}</span>
        </div>
        <mc-icon name="ellipsis-vertical" class="sidebar__profile-options" aria-hidden="true" />
      }
    </button>
  </div>
</aside>
